import ScrollToAnchor from '~/src/components/scroll-to-anchor';
import * as React from 'react';
export default {
  ScrollToAnchor,
  React
};